import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash';
import { components } from 'react-select';
import { get } from 'helpers/api';

import { mapId, mapName } from 'helpers/react_select_helpers';
import { horizontalFormStyles } from 'helpers/react_select_helpers';

const Menu = props => (
  <components.Menu {...props} className="menu-list">
    {props.children}
    <div className="text-create text-center clickable py-3" onClick={props.selectProps.onCreateClick}>
      <strong>+ Create new lead</strong>
    </div>
  </components.Menu>
);

Menu.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.shape({
    onCreateClick: PropTypes.func.isRequired
  })
};

export default function SaleBuyer({ projectId, selectedLead, onLeadSelected, onNewLeadSelected }) {
  function searchProjects(query, callback) {
    get(`/projects/${projectId}/leads/search`, {
      params: { 'q[name_cont]': query }
    }).then(callback);
  }

  return (
    <AsyncSelect
      components={{ Menu }}
      defaultOptions
      getOptionLabel={lead => lead.name || lead.email}
      getOptionValue={mapId}
      isClearable
      loadOptions={debounce(searchProjects, 300)}
      noOptionsMessage={
        ({ inputValue }) => !inputValue ? 'Enter a name to start searching' : 'No results found'
      }
      placeholder="Select from project leads"
      styles={horizontalFormStyles}
      value={selectedLead}
      onChange={onLeadSelected}
      onCreateClick={() => onNewLeadSelected()}
    />
  );
}

SaleBuyer.propTypes = {
  projectId: PropTypes.number.isRequired,
  selectedLead: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  onLeadSelected: PropTypes.func.isRequired,
  onNewLeadSelected: PropTypes.func.isRequired
};
